Wee.fn.make('header', {
	init: function() {
		var scope = this,
			$search = $('ref:search', scope.$scope);

		scope.$scope = 'ref:header';

		Wee.screen.map([
			{
				min: 4,
				callback: function() {
					var $header = $('ref:header'),
						$body = $($._body);

					$search.insertAfter(
						$('ref:logo', scope.$scope)
					);

					if ($header.isActive && $body.isActive) {
						$header.deactivate();
						$body.deactivate();
					}
				}
			},
			{
				max: 3,
				callback: function() {
					$('ref:iconGroup', scope.$scope).append($search);
					Wee.events.trigger('ref:body', 'click');
				}
			}
		]);

		scope.$private.initHeaderEvents();
	},

	unload: function() {
		$.events.off(false, '.headerEvents');
	}
}, {
	initHeaderEvents: function() {
		var scope = this,
			$header = $('ref:header'),
			$body = $($._body);

		$.events.on({
			'ref:search': {
				click: function() {
					var $searchField = $('ref:searchField');

					if ($header.isActive && $body.isActive && $searchField.val() !== '') {
						$.history.go({
							path: '/search-results?search=' + $searchField.val(),
							request: {
								complete: function() {
									$searchField.val('');
									$('ref:body').deactivate();
									$('ref:header').deactivate();
								}
							}
						});
					}

					$header.activate();
					$body.activate();
					$('ref:searchForm').attr('aria-hidden', false);
					$searchField[0].focus();
				}
			},

			'ref:searchField': {
				keyup: function(e, el) {
					var $searchReset = $('ref:searchReset'),
						$el = $(el);

					if ($el.val() !== '') {
						$searchReset.css('background', '#333');
					} else {
						$searchReset.css('background', '#b2b2b2');
					}
				},

				keydown: function(e, el) {
					var $el = $(el);

					if (e.keyCode === 13 && $el.val() !== '') {
						$.history.go({
							path: '/search-results?search=' + $el.val(),
							request: {
								send: function() {
									document.activeElement.blur();
								},
								complete: function() {
									$el.val('');
									$('ref:body').deactivate();
									$('ref:header').deactivate();
								}
							}
						});
					}
				}
			},

			'ref:searchLabel': {
				click: function() {
					$('ref:header').deactivate();
					$($._body).deactivate();
				}
			},

			'ref:searchReset': {
				click: function(e, el) {
					$('ref:searchField').val('')[0].focus();
					$(el).css('background', '#b2b2b2');

					e.preventDefault();
				}
			},

			'ref:searchClose': {
				click: function() {
					$('ref:header').deactivate();
					$($._body).deactivate();
					$('ref:searchForm').attr('aria-hidden', true);
				}
			},

			'ref:weeTopAlertSectionClose': {
				click: function() {
					scope.positionSearchForm();
				}
			}
		}, {
			namespace: 'headerEvents'
		});
	}
});